import './styles/style-gmp-shadow-dom';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

function loadGoogleMaps(): Promise<void> {
    return new Promise((resolve) => {
        // Skip if already loaded
        if (typeof google !== 'undefined' && google.maps) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places,marker&v=weekly`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = () => {
            console.error('Google Maps API failed to load');
            resolve(); // Resolve anyway to allow app to bootstrap
        };
        document.head.appendChild(script);
    });
}

loadGoogleMaps()
    .then(() => bootstrapApplication(AppComponent, appConfig))
    .catch((err) => console.error('Failed to bootstrap app:', err));

